import { metaResolver } from "resolvers";

const changePasswordPageResolver = (data) => {
  return {
    meta: metaResolver(data.meta),
  };
};

export default changePasswordPageResolver;
